
import { create } from 'zustand';
import ar from './ar';
import en from './en';

type Translations = typeof ar;

const translations: Record<string, Translations> = { ar, en };

interface I18nState {
  language: string;
  dir: 'rtl' | 'ltr';
  t: (key: string, params?: Record<string, string | number>) => string;
  setLanguage: (lang: string) => void;
}

function getTranslation(lang: string, key: string): string {
  const t = translations[lang] || translations['ar'];
  return (t as any)[key] || key;
}

function interpolate(template: string, params?: Record<string, string | number>): string {
  if (!params) return template;
  return Object.entries(params).reduce(
    (str, [k, v]) => str.replace(new RegExp(`\{\{${k}\}\}`, 'g'), String(v)),
    template
  );
}

export const useI18n = create<I18nState>((set) => ({
  language: localStorage.getItem('lang') || 'ar',
  dir: (localStorage.getItem('lang') || 'ar') === 'ar' ? 'rtl' : 'ltr',

  t: (key, params) => {
    const lang = useI18n.getState().language;
    const text = getTranslation(lang, key);
    return interpolate(text, params);
  },

  setLanguage: (lang) => {
    localStorage.setItem('lang', lang);
    const dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', dir);
    document.documentElement.setAttribute('lang', lang);
    set({ language: lang, dir });
  },
}));

// Initialize direction on load
const initLang = localStorage.getItem('lang') || 'ar';
const initDir = initLang === 'ar' ? 'rtl' : 'ltr';
document.documentElement.setAttribute('dir', initDir);
document.documentElement.setAttribute('lang', initLang);
